import Fresh from "./Fresh/Routes";
import Strength from "./Strength/Routes";

export default [...Strength, ...Fresh];
